import angular from 'angular';
import MediaResource from '../MediaResource';
import mediaTile from '../MediaTile/MediaTile';
import config from '../../ConfigModule/ConfigModule';
import MediaDropzoneModule from '../MediaDropzone/MediaDropzoneModule';
import PaginationControlsModule from '../../PaginationControls/PaginationControlsModule';
import uiSelect from 'ui-select';
import gettext from 'angular-gettext';

export default angular.module('cms.media.listing',[
    MediaResource,
    config,
    mediaTile,
    MediaDropzoneModule,
    PaginationControlsModule,
    uiSelect,
    gettext
]).component('cmsMediaListing', {
    template: require('./media-listing.html'),
    bindings: {
        displayLimit: '<',
        selectable: '<',
        onSelect: '&',
        tileClass: '@',
        multiple: '<',
        shouldAutoSelect: '='
    },
    controller: function (MediaResource, $scope, gettextCatalog) {
        /** @ngInject */

        this.defaultDisplayLimit = 10;

        this.selectionData = {};

        this.availableOrders = [];

        this.$onInit = () => {
            this.selectedOrder = this.availableOrders[7];
            this.currentPage = MediaResource.get({
                page: 1,
                order_by: this.selectedOrder.property,
                order_direction: this.selectedOrder.direction,
                limit: this.displayLimit || this.defaultDisplayLimit
            });
        };

        let getAvailableFilters = () => {
            return {
                type: {
                    values: ['image', 'file'].map(type => {
                        return {
                            label: gettextCatalog.getString(type),
                            property: 'type',
                            value: type
                        }
                    }),
                    title: gettextCatalog.getString('Search by type'),
                    selectedPrefix: gettextCatalog.getString('Type'),
                }
            };
        };
        this.availableFilters = getAvailableFilters();

        this.selectedFilters = {
            clientOriginalName: {
                value: ''
            }
        };

        let getFilterLabels = () => {
            return [
                {
                    label: gettextCatalog.getString('name', null, 'As in "Sort by media name"'),
                    property: 'clientOriginalName',
                },
                {
                    label: gettextCatalog.getString('file extension', null, 'As in "Sort by media file extension"'),
                    property: 'extension'
                },
                {
                    label: gettextCatalog.getString('size', null, 'As in "Sort by media file size"'),
                    property: 'size',
                    sortType: 'numeric'
                },
                {
                    label: gettextCatalog.getString('upload date', null, 'As in "Sort by media upload date"'),
                    property: 'createdAt',
                    sortType: 'numeric'
                },
                {
                    label: gettextCatalog.getString('type', null, 'As in "Sort by media type"'),
                    property: 'type'
                }
            ].forEach(filterGroup => {
                this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'asc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });
                this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'desc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });

            });
        };

        let filterLabels = getFilterLabels();

        $scope.$on('language-changed', () => {
            this.availableOrders = [];
            filterLabels = getFilterLabels();
            this.availableFilters = getAvailableFilters();

            this.availableOrders.forEach(function (element) {
                if (element.property === this.selectedOrder.property
                    &&
                    element.direction === this.selectedOrder.direction) {
                    this.selectedOrder = element;
                }
            }, this);
        });

        this.onTileSelectionChange = (selected, media) => {
            Object.keys(this.selectionData).forEach(key => {
                if (!this.multiple && key !== media.id) {
                    delete this.selectionData[key];
                }
                if (this.multiple && key === media.id) {
                    delete this.selectionData[key];
                }
            });

            this.onSelect({media: media, selected: selected});
        };

        this.onRemoved = media => {
            let index = this.currentPage.data.indexOf(media);
            if (index > -1) {
                this.currentPage.data.splice(index, 1)
            }
        };

        this.onUploadAdded = file => {
            let uploadTile = {
                _uploadId: file.upload.uuid,
                type: file.type.indexOf("image") === -1 ? 'file' : 'image',
                clientOriginalName: file.name,
                size: file.size,
                status: file.status
            };
            $scope.$apply(()=> {
                this.currentPage.data.unshift(uploadTile);
            });
        };

        this.onUploadUpdated = (uploadId, file) => {
            this.currentPage.data.forEach((element, index, uploads) => {
                if (element._uploadId === uploadId) {
                    $scope.$apply(() => {
                        uploads[index].status = file.status;
                        uploads[index].dataURL = file.dataURL;
                    });
                }
            });
        };

        this.onUploadSuccess = (uploadId, media) => {
            this.currentPage.data.forEach((element, index, uploads) => {
                if (element._uploadId === uploadId) {
                    $scope.$apply(()=> {
                        delete uploads[index].status;
                        delete uploads[index]._uploadId;
                        uploads[index].key = media.key;
                        uploads[index].id = media.id;
                        if(this.shouldAutoSelect) {
                            this.selectionData[media.id] = media;
                            this.onTileSelectionChange(true, media);
                        }
                    });
                }
            });
        };

        this.onUploadError = (uploadId, file, message) => {
            this.currentPage.data.forEach((element, index, uploads) => {
                if (element._uploadId === uploadId) {
                    $scope.$apply(()=> {
                        uploads[index].status = file.status;
                        uploads[index].errorMessage = message;
                    });
                }
            });
        };

        this.loadPage = page => {
            let filterValues = {};

            Object.keys(this.selectedFilters).forEach(filterProperty => {
                if (this.selectedFilters[filterProperty])
                    filterValues[filterProperty] = this.selectedFilters[filterProperty].value
            });

            this.currentPage.$cancelRequest();

            let criteria = {
                page: page,
                order_by: this.selectedOrder.property,
                order_direction: this.selectedOrder.direction,
                limit: this.displayLimit || this.defaultDisplayLimit,
            };

            this.currentPage = MediaResource.get(Object.assign(criteria, filterValues));

        };

        this.applyFilters = () => {
            this.currentPage.current_page = 1;
            this.loadPage(this.currentPage.current_page)
        };
    }
})
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaListing/MediaListing.js